function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.429 13.5h7.428m0 32.5H9.43V31.173",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.571 13.5h3.715v17.643H7.57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.429 13.5H2V46h7.429V31.173M16.857 13.5h7.429V46h-7.429V31.173",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 13.5h3.714v17.643H15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.714 13.5h7.429m0 32.5h-7.429V31.173",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.857 13.5h3.714v17.643h-3.714z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.714 13.5h-7.429V46h7.429V31.173M46.571 13.5H54V46H46.57V31.173",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.286 13.5H41v17.643h-3.714z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.143 13.5h7.429m0 32.5h-7.429V31.173",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.714 13.5h3.714v17.643h-3.714z"
}));

var SvgPiano = function SvgPiano(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPiano, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Piano.a4723262.svg";
export { ForwardRef as ReactComponent };